import { message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { mapToSelectOptions } from "../../../libs/utils";
import { getOrganizations } from "./api/organizations";
import { Organization } from "./types";

export function useOrganizations() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [organizations, setOrganizations] = useState<Organization[]>([]);

  const orgId = searchParams.get("orgId");

  useEffect(() => {
    (async () => {
      try {
        const list = await getOrganizations();

        if (list?.length) {
          if (!searchParams.get("orgId")) {
            const updatedParams = new URLSearchParams(searchParams);
            updatedParams.set("orgId", list[0].orgId);
            setSearchParams(updatedParams);
          }

          setOrganizations(list);
        }
      } catch (error) {
        message.error("Unable to fetch organizations");
      }
    })();
  }, []);

  const organizationOptions = mapToSelectOptions(organizations, {
    labelKey: "name",
    valueKey: "orgId",
  });

  const changeSelectedOrgId = useCallback(
    (orgId: string) => {
      const updatedParams = new URLSearchParams(searchParams);

      if (orgId) updatedParams.set("orgId", orgId);
      else updatedParams.delete("orgId");

      setSearchParams(updatedParams);
    },
    [searchParams, setSearchParams]
  );

  return {
    orgId,
    organizations,
    organizationOptions,
    changeSelectedOrgId,
  };
}
